<template>
  <div id="EditProfilePage">
    <NavBar/>
    <v-main class="third-bg">
      <div class="container-fluid third-bg py-15">
        <div class="container-md">
          <div class="row">
            <div class="col-12 text-center">
              <h1>
                <span class="font-19 border-bottom-gold px-5">سوابق سفارشات</span>
              </h1>
            </div>
            <div v-for="(item , i) in orders" :key="i" class="col-md-6 col-lg-4">
              <div class="rounded-lg bg-white row p-1 mx-1 py-2">
                <div class="col-6 py-1">وضعیت سفارش</div>
                <div class="col-6 text-left">{{ $TypeInvoiceStatus[item.TypeInvoiceStatus - 1].name }}</div>
                <div class="col-6 py-1">کد پیگیری</div>
                <div class="col-6 py-1 text-left">{{ item.TrackingCode }}</div>
                <div class="col-6 py-1">تاریخ سفارش</div>
                <div class="col-6 py-1 text-left">{{ $convertDate(item.ModifiedDate) }}</div>
                <div class="col-6 py-1">روش پرداخت</div>
                <div class="col-6 py-1 text-left">{{ $TypePayment[item.TypePayment - 1].name }}</div>
                <div class="col-6 py-1" v-if="item.DiscountCodeId !== null"> تخفیف</div>
                <div class="col-6 py-1 text-left" v-if="item.DiscountCodeId !== null">
                  {{ item.DiscountCode.DiscountPercent }} %
                </div>
                <div class="col-6 py-1">مبلغ کل</div>
                <div class="col-6 py-1 text-left">{{ $numberWithCommas(item.TotalAmount) }} تومان</div>
                <div class="col-12 py-1 pointer" @click="seeFactor(item.InvoiceId, item.TypeInvoiceStatus)"><i
                    class="fa-duotone fa-file-lines fa-lg ml-2 mr-1 primary-text"></i> مشاهده فاکتور خرید
                </div>
                <div v-if="item.DeliveryAddressId !== null" class="col-12 py-1 pointer"
                     @click="getAddresses(item.DeliveryAddressId)"><i
                    class="fa-duotone fa-circle-info fa-lg ml-2 primary-text"></i> مشاهده آدرس تحویل گیرنده
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <v-bottom-sheet v-model="openBottomSheetFactorDetail" class="bottom-sheet" scrollable>
        <v-sheet
            class="rounded-t-xl rounded-t-xl overflow-y-auto overflow-x-hidden">
          <div class="row no-gutters align-items-center">
            <div class="col pr-5 py-2 toggle-filter-btn">
              فاکتور خرید
            </div>
            <div class="col text-left pl-4">
              <v-btn icon @click="openBottomSheetFactorDetail = !openBottomSheetFactorDetail">
                <i class="fa-solid fa-circle-xmark fa-2x"></i>
              </v-btn>
            </div>
          </div>
          <div class="my-3 text-center" v-html="factorTitle"></div>
          <div style="overflow: auto">
            <v-data-table
                :headers="headers"
                :items="detailOrder"
                :items-per-page="5"
                :light="true"
                :mobile-breakpoint="680"
                class="data-table"
                :loading="loading"
                fixed-header>

              <template v-slot:[`item.FileUrl`]="{ item }">
                <!--                <div class="p-2 text-center">
                                  <v-img v-if="item.FileUrl != null" :src="$replaceHttps(item.FileUrl)" height="150"
                                         width="150">
                                  </v-img>
                                </div>-->
                <div class="p-2 d-flex justify-content-center">
                  <v-img v-if="item.FileUrl != null" :src="$replaceHttps(item.FileUrl)" contain
                         height="150" width="150">
                  </v-img>
                  <v-img v-else :src="getImgUrl(src)" contain
                         height="100" width="100"></v-img>
                </div>
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <div class="p-2" v-if="item.showFiles">
                  <v-btn class="pt-1" color="primary" icon
                         @click="FilesForDownload(item.FileUrl1,item.FileUrl2,item.FileUrl3,item.FileUrl4,item.FileUrl5 )">
                       <span><i class="fas fa-eye pl-1 "
                       ></i></span>
                  </v-btn>
                </div>
              </template>

              <template v-slot:[`item.TotalRow`]="{ item }">
                <div>
                  {{ $numberWithCommas(item.TotalRow) }}
                </div>
              </template>
            </v-data-table>
          </div>
        </v-sheet>
      </v-bottom-sheet>
      <!--      <v-bottom-sheet v-model="openBottomSheetAddress" class="bottom-sheet" scrollable>
              <v-sheet
                  class="rounded-t-xl rounded-t-xl overflow-y-auto overflow-x-hidden">
                <div class="row no-gutters align-items-center">
                  <div class="col pr-5 py-2 toggle-filter-btn">
                    آدرس تحویل گیرنده
                  </div>
                  <div class="col text-left pl-4">
                    <v-btn icon @click="openBottomSheetAddress = !openBottomSheetAddress">
                      <i class="fa-solid fa-circle-xmark fa-2x"></i>
                    </v-btn>
                  </div>
                </div>
                <div class="px-4 py-4">
                  {{ userAddress }}
                </div>
              </v-sheet>
            </v-bottom-sheet>-->
    </v-main>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showFilesForDownload"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <div class="white--text">
            دانلود فایل ها
          </div>
          <v-btn
              color="primary"
              icon
              @click="showFilesForDownload = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>

        </v-card-title>
        <v-card-text class="pt-6">
          <div class="my-2 mx-8" v-if="addFile1 !== null">
            <a :href="addFile1" target="_blank">
              <v-btn
                  color="primary" class="rounded-lg" small dark elevation="0"
              >
                <span class="font16px">مشاهده فایل ضمیمه1</span>
              </v-btn>
            </a>
          </div>
          <div class="my-2 mx-8" v-if="addFile2 !== null">
            <a :href="addFile2" target="_blank">
              <v-btn
                  color="primary" class="rounded-lg" small dark elevation="0"
              >
                <span class="font16px"> مشاهده فایل ضمیمه2</span>
              </v-btn>
            </a>
          </div>
          <div class="my-2 mx-8" v-if="addFile3 !== null">
            <a :href="addFile3" target="_blank">
              <v-btn
                  color="primary" class="rounded-lg" small dark elevation="0"
              >
                <span class="font16px"> مشاهده فایل ضمیمه3</span>
              </v-btn>
            </a>
          </div>
          <div class="my-2 mx-8" v-if="addFile4 !== null">
            <a :href="addFile4" target="_blank">
              <v-btn
                  color="primary" class="rounded-lg" small dark elevation="0"
              >
                <span class="font16px"> مشاهده فایل ضمیمه4</span>
              </v-btn>
            </a>
          </div>
          <div class="my-2 mx-8" v-if="addFile5 !== null">
            <a :href="addFile5" target="_blank">
              <v-btn
                  color="primary" class="rounded-lg" small dark elevation="0"
              >
                <span class="font16px"> مشاهده فایل ضمیمه5</span>
              </v-btn>
            </a>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="openBottomSheetAddress"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <div class="white--text">
            آدرس تحویل گیرنده
          </div>
          <v-btn
              color="primary"
              icon
              @click="openBottomSheetAddress = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>

        </v-card-title>
        <v-card-text class="pt-6">
          <div class="col-auto">استان: {{Province}}</div>
          <div class="col-auto">شهرستان: {{city}}</div>
          <div class="col-auto">آدرس: {{userAddress}}</div>
          <div class="col-auto">کدپستی: {{ZipCode}}</div>
          <div class="col-auto">پلاک: {{Plak}}</div>
          <div class="col-auto">واحد: {{Vahed}}</div>
          <div class="col-auto">نام گیرنده: {{Name}}</div>
          <div class="col-auto">نام خانوادگی گیرنده: {{Family}}</div>
          <div class="col-auto">شماره همراه گیرنده: {{MobilePhone}}</div>
          <div class="col-auto">کد ملی گیرنده: {{NationalCode}}</div>
          <div class="text-center">
            <v-btn
                color="primary"
                elevation="0"
                @click="$openLink('https://www.google.com/maps/search/?api=1&query='+ lat
                + ','+ lng )"
            >
              لوکیشن
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "OrdersRecords",
  metaInfo: {
    title: 'آموزش املاک-  سوابق سفارشات ',
  },
  components: {NavBar, FooterComponent},
  data: () => ({
    orders: [],
    headers: [
      {text: 'محصول', value: 'Name', sortable: false,},
      {text: 'تخفیف', value: 'Discount', sortable: false,},
      {text: 'عکس', value: 'FileUrl', sortable: false,},
      {text: 'تعداد سفارش', value: 'NumberNeed'},
      {text: ' قیمت کل', value: 'TotalRow', sortable: false,},
      {text: '', value: 'action', sortable: false,},
    ],
    factorTitle: null,
    showFilesForDownload: false,
    detailOrder: [],
    openBottomSheetFactorDetail: false,
    openBottomSheetAddress: false,
    showLoaderDialog: false,
    loading: false,
    orderConfirmation: false,
    addFile1: null,
    addFile2: null,
    addFile3: null,
    addFile4: null,
    addFile5: null,
    invoiceId: null,
    userAddress: null,
    userAddressId: null,
    lat: null,
    lng: null,
    city: null,
    Province: null,
    NationalCode: null,
    MobilePhone: null,
    Family: null,
    Name: null,
    Vahed: null,
    Plak: null,
    ZipCode: null,
    src: 'logo.png'
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/UserInvoices", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.showLoaderDialog = false
            this.orders = json
            /*  if (json.TypeInvoiceStatus === 2){
                this.orderConfirmation = true
              }*/
          })
          .catch(error => console.log('error', error));
    },
    seeFactor(id, typeInvoiceStatus) {
      this.loading = true;
      let showFilesOfInvoiceItem = typeInvoiceStatus === 2;
      this.openBottomSheetFactorDetail = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/InvoiceDetails?invoiceId=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.detailOrder = json.invoiceItems

            for (let i = 0; i < this.detailOrder.length; i++) {
              let product = json.products.filter(x => x.ProductId === this.detailOrder[i].ProductId)[0]
              if (product !== undefined) {
                this.detailOrder[i].showFiles = (product.TypeProduct === 0) && showFilesOfInvoiceItem;
                if (this.detailOrder[i].showFiles) {
                  this.detailOrder[i].FileUrl1 = product.ProtectedFileUrl1;
                  this.detailOrder[i].FileUrl2 = product.ProtectedFileUrl2;
                  this.detailOrder[i].FileUrl3 = product.ProtectedFileUrl3;
                  this.detailOrder[i].FileUrl4 = product.ProtectedFileUrl4;
                  this.detailOrder[i].FileUrl5 = product.ProtectedFileUrl5;
                }
              }
            }
            /* if (json.invoice.TypeInvoiceStatus === 2) {
               this.orderConfirmation = true
             }*/



            this.loading = false
          })
          .catch(error => console.log('error', error));
    },
    getAddresses(id) {
      this.openBottomSheetAddress = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/EditDeliveryAddress?deliveryAddressId=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.userAddress = json.modelInDb.Address
            this.city = json.modelInDb.City.Name
            this.Province = json.modelInDb.Province.Name
            this.ZipCode = json.modelInDb.ZipCode
            this.Plak = json.modelInDb.Plak
            this.Vahed = json.modelInDb.Vahed
            this.Name = json.modelInDb.Name
            this.Family = json.modelInDb.Family
            this.MobilePhone = json.modelInDb.MobilePhone
            this.NationalCode = json.modelInDb.NationalCode
            this.lat = json.modelInDb.Latitude;
            this.lng = json.modelInDb.Longitude;
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    FilesForDownload(file1, file2, file3, file4, file5) {
      this.showFilesForDownload = true
      this.addFile1 = file1
      this.addFile2 = file2
      this.addFile3 = file3
      this.addFile4 = file4
      this.addFile5 = file5

    }
  }
}
</script>

<style scoped>

</style>
